import moment from 'moment/moment';
import { useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import Barcode from 'react-barcode';
import useSWR from 'swr';
import { URLS } from '../../../services/urls';
import _ from 'lodash'
import { sumArray } from '../../../components/utils/functions';

const BonDeSortie = ({ invoice }) => {
  const [toShow, setToShow] = useState();
  const [dimensions, setDimensions] = useState({ width: 100, height: 500 });
  const { data: inv, isLoading, mutate } = useSWR(URLS.INVOICES.details(invoice?.id));

  const ticketRef = useRef();

  const handlePrint = useReactToPrint({
    pageStyle: `@media print {
            @page {
              size: ${dimensions.width}mm ${dimensions.height}mm;
              margin: 0;
            }
          }`,
    content: () => ticketRef?.current,
    documentTitle: 'Facture ' + inv?.reference,
    // onBeforeGetContent: () => setHideButton(true),
    // onAfterPrint: () => setHideButton(true)
  });

  useEffect(() => {
    var elem = document.getElementById("invoiceTicket");
    if(elem) {
    var rect = elem.getBoundingClientRect();
    setDimensions(prev => {
        return {
            "height": rect.width * 0.4645833,
            "width": 90,
        }
    })
    }
  }, []);
  return (
    <div>
      <div className="row">
        <div className="col-md-2 col-2"></div>
        <div className="col-md-8 col-8 text-center">
          <div className="d-flex">
            <div className="m-auto" style={{width: '80%'}}>
              <div className="mb-3 border-md-3 border p-3" ref={ticketRef} id='invoiceTicket'>
                <div className="row">
                  <div className="col-12">
                    <div>
                      <img
                        src="/assets/images/logo-dark.webp"
                        alt=""
                        height="70"
                        className=" mx-auto"
                      /> <br />
                      <p className="">INSTITUT DE BIEN - ETRE - COIFFURES - SOINS CORPORELS - MASSAGE - ESPACE DETENTE</p>
                      <strong>RCCM</strong>: RC/DLN/2021/B/652 {" "} <strong>NIU</strong>: M022118505410B 
                      <p className="mb-1 text-center">
                        <strong>Agence: </strong> {inv?.agency?.name} <br /> 
                      </p>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="">
                      
                      <p className="mb-1 text-center">
                        <strong>Code client: </strong> {inv?.order?.customer?.reference}
                      </p>
                      <p className="mb-1 text-center">
                      <strong>Caissier: </strong>{' '}
                        {inv?.created_by?.first_name} {inv?.created_by?.last_name}
                      </p>
                    </div>
                  </div>
                  <div className="col-12  text-center">
                    <div>
                      <p className="mb-1 text-center"> <strong>Date:</strong> {moment(inv?.created_at).format('DD/MM/YYYY HH:MM')} </p>
                      {/* <p className="mb-1 text-center">
                        <strong>Code Facture: </strong> {inv?.reference}
                      </p> */}
                    </div>
                    <hr style={{borderTop: "dotted 2px"}} />
                    <div>
                        {
                            inv?.order?.items?.map((item) => (
                                <div className="d-flex py-1">
                                    <span>{item?.item?.title}</span>
                                    <span className="ms-auto">{item?.item?.price}</span>
                                </div>
                            ))
                        }
                    </div>
                    <hr style={{borderTop: "dotted 2px"}} />
                    <div className="py-1">
                        <div className="d-flex py-1">
                            <span>SOUS TOTAL</span>
                            <span className="ms-auto">{Math.round(inv?.sub_total) ?? 0}</span>
                        </div>
                        {inv?.discount_amount > 0 && <div className="d-flex py-1">
                            <span>REMISE</span>
                            <span className="ms-auto">{Math.round(inv?.discount_amount ?? 0)}</span>
                        </div>}
                        <div className="d-flex py-1">
                            <span>HT</span>
                            <span className="ms-auto">{Math.round(inv?.price_exclude_tax)}</span>
                        </div>
                        <div className="d-flex py-1">
                            <span>TVA (19.25%)</span>
                            <span className="ms-auto">{Math.round(inv?.tax_value)}</span>
                        </div>
                        <div className="d-flex py-1">
                            <span>TTC</span>
                            <span className="ms-auto">{Math.round(inv?.amount)}</span>
                        </div>
                    </div>
                    <hr style={{borderTop: "dotted 2px"}} />
                    <div className="py-1">
                        {/* <div className="d-flex py-1">
                            <span>Encaissé</span>
                            <span className="ms-auto">{
                              sumArray(inv?.payments?.filter((i) => i.payment_method != "DETTE")?.map(i => parseInt(i?.amount)) ?? [])
                            }</span>
                        </div> */}
                        {/* {
                            inv?.amount_received - inv?.amount > 0 &&
                            (
                                <div className="d-flex py-1">
                                    <span>Rendu</span>
                                    <span className="ms-auto">{inv?.amount_received - inv?.amount}</span>
                                </div>
                            )
                        } */}
                        {/* {
                            _.filter(inv ?? [], {payment_method: "DETTE"}).length > 0 &&
                            (
                                <div className="d-flex py-1">
                                    <span>Dette</span>
                                    <span className="ms-auto">{_.filter(inv ?? [], {method: "DETTE"})[0]?.amount}</span>
                                </div>
                            )
                        } */}
                        <div className="d-flex py-1">
                            <span>Mode de Règlement</span>
                            <span className="ms-auto">
                            {inv?.payments?.map(
                                (pm, idx) =>
                                  String(pm.payment_method).replace('_', ' ') +
                                  (idx + 1 == inv?.payments?.length ? '' : ', ')
                              )}
                            </span>
                        </div>
                    </div>
                    <hr style={{borderTop: "dotted 2px"}} />
                    <div>
                        <Barcode height={50} value={inv?.reference} width={1} />
                    </div>
                    <div className="d-flex flex-column">
                      <div className="mx-auto mt-3">
                        <p className="small">Merci pour votre visite et à bientôt!</p>
                      </div>
                      <div className="ms-auto">
                        <span className="small">Imprimé le: {moment().format("DD/MM/YYYY HH:MM")}</span>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          <div>
            <button
              type="button"
              className="btn btn-primary waves-effect waves-light"
              onClick={handlePrint}
            >
              {' '}
              Imprimer 
            </button>
          </div>
        </div>
        <div className="col-md-2 col-2"></div>
      </div>
    </div>
  );
};

export default BonDeSortie;
